export default "__VITE_ASSET__BMJBHHqm__"